import Moment from 'moment';
import i18n from '@/locales';

const localeDateFormatter = (type, unix) => {
  if (unix) {
    const unixMoment = Moment.unix(unix).locale(i18n.locale);

    switch (type) {
      case 'calendar':
        return unixMoment.calendar();
      case 'fromNow':
      case 'relative':
        return unixMoment.fromNow();
      case 'toNow':
        return unixMoment.toNow();
      case 'short':
        return unixMoment.format('l');
      case 'long':
        return unixMoment.format('LL');
      case 'timestamp':
        return unixMoment.format('lll');
      case 'date-field':
        return unixMoment.format('YYYY-MM-DD');
      default:
        return 'Invalid Date Type';
    }
  } else {
    return 'Invalid Timestamp';
  }
};

export default localeDateFormatter;
